var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26.3 24.4",
    style: {
      enableBackground: "new 0 0 26.3 24.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2A275C;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.6,24.4v-6.7h-4.9v6.6c-0.1,0-0.1,0-0.1,0c-1.5,0-2.9,0-4.4,0c-1.4,0-2.5-1.2-2.5-2.5c0-2.2,0-4.3,0-6.5 c0-0.2,0.2-0.5,0.3-0.7c1.9-1.9,3.8-3.8,5.8-5.8c0.9-0.9,1.8-1.8,2.8-2.8c0.4-0.4,0.8-0.4,1.2,0c2.8,2.8,5.7,5.7,8.5,8.5 c0.3,0.3,0.4,0.5,0.4,0.9c0,2,0,4.1,0,6.1c0,1.3-0.8,2.4-2.1,2.7c-0.2,0.1-0.4,0.1-0.7,0.1c-1.4,0-2.7,0-4.1,0 C15.7,24.4,15.7,24.4,15.6,24.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.8,4c0-0.6,0-1,0-1.5c0-1.1,1-1.8,2-1.5c0.5,0.2,0.9,0.6,0.9,1.2c0,0.2,0,0.3,0,0.5c0,1.3,0,2.7,0,4 c0,0.2,0.1,0.3,0.2,0.5c1.2,1.2,2.5,2.5,3.7,3.7c0.7,0.7,0.7,1.5,0.2,2.2c-0.5,0.6-1.4,0.7-2,0.2c-0.1-0.1-0.3-0.2-0.4-0.3 c-3.2-3.2-6.4-6.4-9.6-9.6c-0.6-0.6-1-0.6-1.6,0C9.1,6.6,5.9,9.8,2.7,13c-0.4,0.4-0.8,0.6-1.4,0.5c-1.1-0.2-1.7-1.5-0.9-2.4 c0.1-0.1,0.2-0.2,0.3-0.3C3.8,7.7,7,4.5,10.2,1.2c1.6-1.6,4.3-1.6,5.8,0c0.8,0.9,1.7,1.7,2.5,2.6C18.6,3.8,18.7,3.9,18.8,4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home_icon.651eadc9f896a1cd80366a8783fad765.svg";
export { ForwardRef as ReactComponent };